import React from 'react'

function VisitUs() {
    return (
        <div className='justify-between items-center overflow-hidden text-[#555555]'>
            <div className='text-left'>
                <h2 className='text-2xl font-bold text-[#3A3939]'>Visit Us</h2>
                <p className='text-xs py-4'>GRA ikeja, Lagos, Nigeria<br /> Phone: +2349049440746</p>
            </div>
            <div className='py-10 text-left'>
                <h2 className='text-2xl font-bold text-[#3A3939]'>Get In Touch</h2>
                <p className='text-xs py-4'>You can get in touch with us on this provided email.
                    <br /><span className="pt-8">Email: adebolabadejo11@gmail.com</span></p>
            </div>
        </div>
    )
}

export default VisitUs